module.exports = __webpack_public_path__ + "static/media/siri09.890962b4.jpg";